import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import PageWrapper from '../components/PageWrapper.vue';
import Login from '../views/LoginPage.vue';
import Error404 from '../views/Error404Page.vue';
import SelectClient from '../views/SelectClient.vue';
import ForgottenPassword from '../views/ForgottenPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import EmbededElement from '../components/EmbededElement.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/Dashboard',
    name: 'dashboard',
    component: PageWrapper,
    children: [
      {
        path: '/Reporting/Home*',
        name: 'embed',
        component: EmbededElement,
        meta: {
          title: 'Home',
          header: 'Home V2',
          feature: 'WebeoReportingV2.3-Homepage',
        },
      },
      {
        path: '/Reporting/*',
        name: 'embed',
        component: EmbededElement,
        meta: {
          title: 'Reporting',
          header: 'Reporting',
          feature: 'WebeoReportingV2',
        },
      },
    ],
  },
  {
    path: '/SelectClient',
    component: SelectClient,
    meta: { title: 'Select Client' },
  },
  {
    path: '/Login',
    component: Login,
    meta: { title: 'Login', anon: true },
  },
  {
    path: '/ForgottenPassword',
    component: ForgottenPassword,
    meta: { title: 'Forgotten Password', anon: true },
  },
  {
    path: '/ResetPassword',
    component: ResetPassword,
    meta: { title: 'Reset Password', anon: true },
  },
  {
    path: '*',
    component: Error404,
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

NProgress.configure({ minimum: 0.4 });

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done(true);
});

const oldPush = router.push.bind(router);
router.push = (r) => oldPush(r).catch(() => {
  NProgress.done(true);
});

export default router;
